import axios from '../plugins/axios.js';
const _apiClient = {
    /**
     * 008_用户使用账号密码_手机号_Token登陆.md
     * @see {@link https://codeup.aliyun.com/mosoink/document/coreapi/blob/master/001_%E7%94%A8%E6%88%B7/008_%E7%94%A8%E6%88%B7%E4%BD%BF%E7%94%A8%E8%B4%A6%E5%8F%B7%E5%AF%86%E7%A0%81_%E6%89%8B%E6%9C%BA%E5%8F%B7_Token%E7%99%BB%E9%99%86.md}
     * @param {string} token 用来token登陆获取用户信息
     */
    getUserInfo: function(token) {
        return axios.request({
            method: 'POST',
            url: '/passports/token-login',
            data: token
        });
    }
}
export default _apiClient;